import { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom"; // to get activityUrl from route
import { useDispatch } from "react-redux";
import { setActivityCode, setActivityGroup } from "../../store/slices/IdSlice";
import { Activities, ActivityDetail, getDataForDedActivityDetailPageApi } from "../../lib/api";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./DedActivityDetail.css";

/* --------- Main Page --------- */
const DedActivityDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activityUrl, activityCode } = useParams<{ activityUrl: string, activityCode: string }>();
  const [activity, setActivity] = useState<Activities | null>(null);
  const [groupActivity, setGroupActivity] = useState<Activities[]>([]);
  const [loading, setLoading] = useState(true);


  const fetchActivityDetail = useCallback(async (activityCodeS: string) => {
    setLoading(true);
    try {
      const data: ActivityDetail = await getDataForDedActivityDetailPageApi(activityCodeS);
      setActivity(data.activity);
      setGroupActivity(data.groupActivity);
    } catch (err) {
      console.error("Failed to fetch activities:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch category & subActivities
  useEffect(() => {
    if (!activityCode) return;
    fetchActivityDetail(activityCode);
  }, [activityCode]);

  const navigateTo = useCallback((path: string) => navigate(path), [navigate]);
  const handleBack = () => navigateTo(`/dubai-economy/activities/${activityUrl}`);

  const handleGroupClick = (groupName: string) => {
    dispatch(setActivityGroup(groupName));
    navigateTo(`/dubai-economy/activities/${activityUrl}?activityGroup=${groupName}`);
  };
  const handleActivityClick = (code: string) => {
    dispatch(setActivityCode(code));
    navigateTo(`/dubai-economy/activities/${activityUrl}/${code}`);
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!activity)
    return (
      <div className="text-center py-5 text-muted">No category found.</div>
    );

  return (
    <div className="container py-4 py-md-5">
      {/* Heading + count */}
      <div className="ded-activity-topline">
        <div className="ded-activity-title" onClick={() => handleBack()}>
          <a href="javascript:void(0);">
            {" "}
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </a>
        </div>
      </div>

      {/* Table */}
      <div className="ded-activity-table-wrap d-flex-act-sec">
        <div className="left-activity-details">
          <ul>
            <li><span>Activity</span>{activity.name}</li>
            <li><span>Activity Code</span>{activity.activityCode}</li>
            <li><span>Activity Group</span>{activity.groupName}</li>
            <li><span>License Type</span>{activity.licenseType}</li>
            <li><span>Activity description</span>{activity.description}</li>
            <li><span>Approval</span>{activity.approval}</li>
          </ul>
        </div>
        <div className="right-activity-details">
          <div className="ded-activity-topline">
            <div
              className="ded-activity-subtitle"
              onClick={() => handleGroupClick(activity.groupName)}
            >
              Activities categorized under the same group
              <a href="javascript:void(0);">View All</a>
            </div>
          </div>
          <div className="ded-activity-table">
            <table className="table mb-0 ">
              <thead>
                <tr>
                  <th style={{ width: "140px" }}>Activity Code</th>
                  <th>Activity</th>
                </tr>
              </thead>
              <tbody>
                {groupActivity.map((item) => (
                  <tr key={`detail-${item.categoryID}-${item.activityCode}`} className="ded-activity-row">
                    <td className="ded-activity-code" onClick={() => handleActivityClick(item.activityCode)}>
                      <a href="javascript:void(0);" aria-label={`Open ${item.activityCode}`}>
                        {item.activityCode}
                      </a>
                    </td>
                    <td>{item.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DedActivityDetail;
